import { render, staticRenderFns } from "./OverviewPanel.vue?vue&type=template&id=595e9e1b&scoped=true"
import script from "./OverviewPanel.vue?vue&type=script&lang=js"
export * from "./OverviewPanel.vue?vue&type=script&lang=js"
import style0 from "./OverviewPanel.vue?vue&type=style&index=0&id=595e9e1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595e9e1b",
  null
  
)

export default component.exports